import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, List, ListItem, useTheme } from '@mui/material'
import { LegendContent, LegendPopper, LegendTitle } from './LegendsStyles'

const stateToColor = (state, theme) => {
  if (theme && theme.palette) {
    switch (state) {
      case 'red_state':
        return theme.palette.error.main
      case 'orange_state':
        return theme.palette.warning.main
      case 'green_state':
        return theme.palette.success.main
      case 'purple_state':
        return '#8866A6'
      case 'grey_state':
        return theme.palette.grey[400]
      default:
        return 'white'
    }
  }
}

const Item = ({
  state,
  content = '',
  ...props
}) => {
  const theme = useTheme()
  return (
    <ListItem key={state} sx={{ padding: '4px 0', gap: 1 }} {...props}>
      <Box sx={{ width: 16, height: 16, borderRadius: 0.5, backgroundColor: stateToColor(state, theme) }}/>
      <LegendContent>{content}</LegendContent>
    </ListItem>
  )
}

const GlobalLegend = ({
  mapsView,
  ...props
}) => {
  const { t } = useTranslation()
  return (
    <LegendPopper {...props}>
      <LegendTitle>{t('cartography.maps.legend.site_status')}</LegendTitle>
      <List sx={{ p: 0 }}>
        <Item state="red_state" content={t('cartography.maps.legend.red_state')}/>
        <Item state="orange_state" content={t('cartography.maps.legend.orange_state')}/>
        <Item state="green_state" content={t('cartography.maps.legend.green_state')}/>
      </List>
    </LegendPopper>
  )
}

export default GlobalLegend
